import { authPost } from "@api";

import { CreateParentOrgResponse } from "@pages/settings/types";
export const createParentOrg = (
  deploymentId: string
): Promise<CreateParentOrgResponse> => {
  const path = `/api/agent/deployments/${deploymentId}/organizations`;
  return authPost<{}, CreateParentOrgResponse>(path, {});
};
